export default __webpack_public_path__ + "static/media/w_m_2022_h.af3ab3c7.jpeg";